// Mock data for Saudi Founding Story website

export const content = {
  ar: {
    nav: {
      brand: 'يوم التأسيس',
      langToggle: 'English',
    },
    hero: {
      title: 'قصة بدايتنا',
      subtitle: 'ثلاثة قرون من المجد والعزيمة... من الدرعية إلى العالم',
      cta: 'اكتشف القصة',
    },
    story: {
      title: 'الرواية',
      paragraphs: [
        'في قلب الجزيرة العربية، حيث امتدّت الرمال الذهبية على مدّ البصر، وارتفعت الجبال شامخةً كحرّاسٍ للزمن، وُلدت قصةٌ غيّرت مجرى التاريخ. في عام ١٧٢٧م، أسّس الإمام محمد بن سعود الدولة السعودية الأولى في الدرعية، واضعًا حجر الأساس لحضارة ستمتد عبر القرون.',
        'كانت الدرعية واحةً للعلم والتجارة، ومنارةً يهتدي بها المسافرون عبر صحراء نجد. من أسوارها الطينية العريقة، انطلقت رؤية دولة توحّد القبائل وتنشر الأمان في ربوع الجزيرة العربية. لم تكن مجرد مدينة، بل كانت حلمًا تحوّل إلى واقع.',
        'مرّت الدولة السعودية بمراحل من التحدّي والصمود. ففي عام ١٨٢٤م، أعاد الإمام تركي بن عبدالله تأسيس الدولة السعودية الثانية، مستلهمًا إرث أجداده وعزيمتهم. واستمرّ هذا الإصرار حتى جاء الملك عبدالعزيز بن عبدالرحمن آل سعود، الذي استردّ الرياض عام ١٩٠٢م في ملحمة بطولية لا تزال تُروى حتى اليوم.',
        'وفي عام ١٩٣٢م، توّج الملك عبدالعزيز مسيرة الكفاح بتوحيد المملكة العربية السعودية تحت رايةٍ واحدة، محقّقًا حلم الأجداد في بناء دولة قوية وموحّدة. من الدرعية إلى الرياض، ومن الصحراء إلى العالم، كُتبت قصة وطنٍ لا يعرف المستحيل.',
      ],
    },
    features: [
      {
        num: '01',
        title: 'حي الطريف التاريخي — الدرعية',
        subtitle: 'مهد الدولة السعودية الأولى',
        image: 'https://images.unsplash.com/photo-1584439152550-e7a4510454c0?w=1200&q=80',
      },
      {
        num: '02',
        title: 'العمارة النجدية',
        subtitle: 'فنون معمارية تروي حكاية الأصالة',
        image: 'https://images.pexels.com/photos/30852821/pexels-photo-30852821.jpeg?auto=compress&cs=tinysrgb&w=1200',
      },
      {
        num: '03',
        title: 'عصر التوحيد',
        subtitle: 'من الحلم إلى الوحدة',
        image: 'https://images.unsplash.com/photo-1755412734479-c0687daab775?w=1200&q=80',
      },
    ],
    timeline: {
      title: 'مسيرة ثلاثة قرون',
      events: [
        {
          year: '١٧٢٧',
          title: 'تأسيس الدولة السعودية الأولى',
          desc: 'أسّس الإمام محمد بن سعود الدولة السعودية الأولى في الدرعية',
        },
        {
          year: '١٨٢٤',
          title: 'الدولة السعودية الثانية',
          desc: 'أعاد الإمام تركي بن عبدالله تأسيس الدولة من جديد',
        },
        {
          year: '١٩٠٢',
          title: 'استرداد الرياض',
          desc: 'استعاد الملك عبدالعزيز الرياض في ملحمة بطولية خالدة',
        },
        {
          year: '١٩٣٢',
          title: 'توحيد المملكة',
          desc: 'إعلان توحيد المملكة العربية السعودية تحت راية واحدة',
        },
      ],
    },
    footer: {
      title: 'يوم التأسيس السعودي',
      years: '١٧٢٧ — ٢٠٢٧',
      tagline: 'ثلاثة قرون من العزّ والمجد',
    },
    collectible: {
      eyebrow: 'إصدار محدود',
      title: 'شرح مجسم يوم التأسيس السعودي',
      ideaTitle: 'فكرة المجسم',
      ideaText: 'المجسم يجسد إحدى القلاع التراثية التي شُيّدت في بداية تأسيس الدولة السعودية الأولى، تعبيرًا عن القوة، الوحدة، والأصالة.',
      badges: [
        { label: 'الأصالة', icon: 'palm' },
        { label: 'القوة', icon: 'shield' },
        { label: 'الوحدة', icon: 'unity' },
      ],
      partsTitle: 'أجزاء المجسم',
      hotspots: [
        { num: '01', mark: '1', title: 'الأبراج الدفاعية', desc: 'تمثل القوة والحماية وترمز إلى البناء المتين والصمود.', icon: 'tower' },
        { num: '02', mark: '2', title: 'الأسوار', desc: 'ترمز إلى الوحدة والترابط والحدود التي تحمي الكيان.', icon: 'wall' },
        { num: '03', mark: '3', title: 'بوابة الدخول', desc: 'تمثل البداية والانطلاق، وترمز إلى الترحيب والأمان.', icon: 'gate' },
        { num: '04', mark: '4', title: 'المباني الداخلية', desc: 'تعكس الحياة والاستقرار وترمز إلى المجتمع العريق.', icon: 'building' },
        { num: '05', mark: '5', title: 'القاعدة الأرضية', desc: 'تجسّد الأرض الصلبة والجذور الراسخة التي بُني عليها الوطن.', icon: 'base' },
      ],
      materialsTitle: 'المواد المستخدمة',
      materials: [
        { label: 'المجسم', value: 'تصميم تراثي فاخر مستوحى من العمارة السعودية.', icon: 'tower' },
        { label: 'البلورة', value: 'كريستال شفاف عالي النقاء.', icon: 'crystal' },
        { label: 'القاعدة', value: 'خشب فاخر.', icon: 'wood' },
        { label: 'النقش والطباعة', value: 'طباعة ليزر عالية الدقة.', icon: 'engrave' },
      ],
      dimensionsTitle: 'أبعاد المجسم',
      crystalDimsTitle: 'أبعاد البلورة',
      baseDimsTitle: 'أبعاد القاعدة',
      crystalDims: [
        { label: 'ارتفاع البلورة', value: '10 سم' },
        { label: 'عرض البلورة', value: '6 سم' },
        { label: 'طول البلورة', value: '8 سم' },
      ],
      baseDims: [
        { label: 'ارتفاع القاعدة', value: '3 سم' },
        { label: 'عرض القاعدة', value: '8 سم' },
        { label: 'طول القاعدة', value: '8 سم' },
      ],
      tapHint: 'اضغط على أي نقطة لاكتشاف تفاصيل المجسم',
    },
    customize: {
      eyebrow: 'إصدار خاص بالشركات',
      title: 'صمّم تذكار شركتك',
      subtitle: 'انقش هوية شركتك على تصميم احتفالي رسمي بمناسبة مرور ٣٠٠ عام على تأسيس المملكة',
      cta: 'خصّص نسختك الخاصة',
      modalTitle: 'مصمّم الإصدار الخاص',
      modalSubtitle: 'ارفع شعارك واكتب اسم شركتك لتحصل على تذكار يوم التأسيس بصيغة فاخرة جاهزة للطباعة والنشر',
      uploadLabel: 'شعار شركتك',
      uploadHint: 'PNG أو SVG بخلفية شفافة (موصى به)',
      uploadButton: 'اختر الملف',
      companyLabel: 'اسم الموظف',
      companyPlaceholder: 'أدخل اسم الموظف',
      backgroundLabel: 'الخلفية',
      goldLabel: 'تحويل الشعار إلى ذهبي',
      removeLogo: 'إزالة الشعار',
      resetBtn: 'إعادة التعيين',
      downloadBtn: 'تنزيل التصميم HD',
      previewLabel: 'معاينة حية',
      headline: 'يوم التأسيس السعودي',
      ageText: 'عام',
      yearsText: '١٧٢٧ — ٢٠٢٧',
      tagline: 'ثلاثة قرون من العزّ والمجد',
      tributeText: 'إصدار تذكاري مهدى من',
      bgOptions: [
        { id: 'diriyah', label: 'الدرعية' },
        { id: 'desert', label: 'الصحراء' },
        { id: 'unification', label: 'التوحيد' },
      ],
      closeBtn: 'إغلاق',
    },
  },
  en: {
    nav: {
      brand: 'Founding Day',
      langToggle: 'العربية',
    },
    hero: {
      title: 'Our Founding Story',
      subtitle: 'Three centuries of glory and determination... from Diriyah to the world',
      cta: 'Discover the Story',
    },
    story: {
      title: 'The Narrative',
      paragraphs: [
        'In the heart of the Arabian Peninsula, where golden sands stretched as far as the eye could see, and majestic mountains stood as guardians of time, a story was born that changed the course of history. In 1727 CE, Imam Muhammad bin Saud founded the First Saudi State in Diriyah, laying the cornerstone for a civilization that would extend across centuries.',
        'Diriyah was an oasis of knowledge and trade, a beacon that guided travelers across the Najd desert. From its ancient mud walls, a vision was launched of a state that would unite the tribes and spread security throughout the Arabian Peninsula. It was not just a city, but a dream that became reality.',
        'The Saudi State went through stages of challenge and resilience. In 1824, Imam Turki bin Abdullah re-founded the Second Saudi State, drawing inspiration from his ancestors heritage and determination. This persistence continued until King Abdulaziz bin Abdulrahman Al Saud recovered Riyadh in 1902 in an epic heroism still told today.',
        'In 1932, King Abdulaziz crowned the journey of struggle by unifying the Kingdom of Saudi Arabia under a single banner, achieving the ancestors dream of building a strong, unified state. From Diriyah to Riyadh, and from the desert to the world, the story of a nation that knows no impossible was written.',
      ],
    },
    features: [
      {
        num: '01',
        title: 'At-Turaif District — Diriyah',
        subtitle: 'Cradle of the First Saudi State',
        image: 'https://images.unsplash.com/photo-1584439152550-e7a4510454c0?w=1200&q=80',
      },
      {
        num: '02',
        title: 'Najdi Architecture',
        subtitle: 'Architectural arts that tell a tale of authenticity',
        image: 'https://images.pexels.com/photos/30852821/pexels-photo-30852821.jpeg?auto=compress&cs=tinysrgb&w=1200',
      },
      {
        num: '03',
        title: 'Era of Unification',
        subtitle: 'From a dream to unity',
        image: 'https://images.unsplash.com/photo-1755412734479-c0687daab775?w=1200&q=80',
      },
    ],
    timeline: {
      title: 'A Journey of Three Centuries',
      events: [
        {
          year: '1727',
          title: 'Founding of the First Saudi State',
          desc: 'Imam Muhammad bin Saud founded the First Saudi State in Diriyah',
        },
        {
          year: '1824',
          title: 'The Second Saudi State',
          desc: 'Imam Turki bin Abdullah re-established the state anew',
        },
        {
          year: '1902',
          title: 'Recovery of Riyadh',
          desc: 'King Abdulaziz recovered Riyadh in an immortal heroic epic',
        },
        {
          year: '1932',
          title: 'Unification of the Kingdom',
          desc: 'Declaration of the unification of the Kingdom of Saudi Arabia under one banner',
        },
      ],
    },
    footer: {
      title: 'Saudi Founding Day',
      years: '1727 — 2027',
      tagline: 'Three centuries of glory and honor',
    },
    collectible: {
      eyebrow: 'Limited Edition',
      title: 'Saudi Founding Day Model Explanation',
      ideaTitle: 'Model Idea',
      ideaText: 'The model represents one of the traditional forts built during the foundation of the first Saudi state, symbolizing strength, unity, and authenticity.',
      badges: [
        { label: 'Authenticity', icon: 'palm' },
        { label: 'Strength', icon: 'shield' },
        { label: 'Unity', icon: 'unity' },
      ],
      partsTitle: 'Parts of the Model',
      hotspots: [
        { num: '01', mark: '1', title: 'Defensive Towers', desc: 'Embody strength and protection — a metaphor for solid construction and resilience.', icon: 'tower' },
        { num: '02', mark: '2', title: 'Fortress Walls', desc: 'Symbolize unity and cohesion, and the borders that protect the nation.', icon: 'wall' },
        { num: '03', mark: '3', title: 'Main Entrance', desc: 'Represents the beginning and the launch — a symbol of welcome and safety.', icon: 'gate' },
        { num: '04', mark: '4', title: 'Inner Buildings', desc: 'Reflect life and stability — a tribute to the deep-rooted society.', icon: 'building' },
        { num: '05', mark: '5', title: 'Base Platform', desc: 'Embodies the firm land and the deep roots upon which the nation was built.', icon: 'base' },
      ],
      materialsTitle: 'Materials Used',
      materials: [
        { label: 'Model', value: 'Luxury heritage-inspired design based on traditional Saudi architecture.', icon: 'tower' },
        { label: 'Crystal', value: 'High-purity transparent crystal.', icon: 'crystal' },
        { label: 'Base', value: 'Premium wood.', icon: 'wood' },
        { label: 'Engraving & Printing', value: 'High-precision laser engraving.', icon: 'engrave' },
      ],
      dimensionsTitle: 'Model Dimensions',
      crystalDimsTitle: 'Crystal Dimensions',
      baseDimsTitle: 'Base Dimensions',
      crystalDims: [
        { label: 'Crystal Height', value: '10 cm' },
        { label: 'Crystal Width', value: '6 cm' },
        { label: 'Crystal Length', value: '8 cm' },
      ],
      baseDims: [
        { label: 'Base Height', value: '3 cm' },
        { label: 'Base Width', value: '8 cm' },
        { label: 'Base Length', value: '8 cm' },
      ],
      tapHint: 'Tap any hotspot to explore the model',
    },
    customize: {
      eyebrow: 'Corporate Edition',
      title: 'Design Your Company Keepsake',
      subtitle: 'Engrave your brand identity into an official commemorative artwork for 300 years of the Saudi state',
      cta: 'Customize Your Edition',
      modalTitle: 'Limited Edition Designer',
      modalSubtitle: 'Upload your logo and enter your company name to receive a luxury Saudi Founding Day keepsake — ready to print and share',
      uploadLabel: 'Company Logo',
      uploadHint: 'PNG or SVG with transparent background (recommended)',
      uploadButton: 'Choose File',
      companyLabel: 'Employee Name',
      companyPlaceholder: 'Enter employee name',
      backgroundLabel: 'Background',
      goldLabel: 'Convert logo to gold',
      removeLogo: 'Remove Logo',
      resetBtn: 'Reset',
      downloadBtn: 'Download HD Artwork',
      previewLabel: 'Live Preview',
      headline: 'Saudi Founding Day',
      ageText: 'Years',
      yearsText: '1727 — 2027',
      tagline: 'Three centuries of glory and honor',
      tributeText: 'A commemorative edition by',
      bgOptions: [
        { id: 'diriyah', label: 'Diriyah' },
        { id: 'desert', label: 'Desert' },
        { id: 'unification', label: 'Unification' },
      ],
      closeBtn: 'Close',
    },
  },
};

export const heroImage = 'https://images.unsplash.com/photo-1645891697649-6548872ce502?w=1920&q=85';
